const API_URLS = {
  rateOptions: "https://backend.sureship.in/publicRoutes/getRateOptions",
tracking: "https://backend.sureship.in/tracking/trackall",
  // tracking: "http://localhost:3500/tracking/trackall",



  internationalRates:
    "https://backend.sureship.in/publicRoutes/shipmozo/international-rates",
  shipmozourl: "https://app.sureship.in/orders/add/?paramsData=",
  contact: "https://backend.sureship.in/Query/contact"

};

// Function to generate shipmozourl with paramsData
// export const getShipmozoUrl = (paramsData) => {
//   const paramsDataString = encodeURIComponent(JSON.stringify(paramsData));
//   return `${API_URLS.shipmozourl}${paramsDataString}`;
// };

// const API_URLS = {
//   rateOptions: "http://192.168.1.104:3500/publicRoutes/getRateOptions",
//   tracking: "http://localhost:3500/tracking/trackall",
//   contact: "http://localhost:3500/Query/contact",
//   internationalRates:
//     "http://192.168.1.104:3500/publicRoutes/shipmozo/international-rates",
//   // "http://localhost:3500/publicRoutes/shipmozo/international-rates", 

//   shipmozourl: "https://backend.sureship.in/orders/add/?paramsData="
// };
export const getShipmozoUrl = (paramsData) => {
  const paramsDataString = encodeURIComponent(JSON.stringify(paramsData));
  return `${API_URLS.shipmozourl}${paramsDataString}`;
};

export default API_URLS;
